import { createContext } from 'react';
import { TASKS } from '../../constants/tasks.constant';

export const TasksContext = createContext({
  tasks: TASKS(),
});

export const TasksProvider = TasksContext.Provider;
